module.exports = __webpack_public_path__ + "static/media/footer-post-signup-facebook.103027ee.svg";